import { createElementBlock as t, openBlock as o, createElementVNode as l } from "vue";
const s = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-clock"
};
function r(n, e) {
  return o(), t("svg", s, e[0] || (e[0] = [
    l("path", {
      d: "M14.1178 16.9027C14.1178 17.3169 14.4536 17.6527 14.8678 17.6527C15.282 17.6527 15.6178 17.3169 15.6178 16.9027H14.1178ZM15.6178 11.5217C15.6178 11.1075 15.282 10.7717 14.8678 10.7717C14.4536 10.7717 14.1178 11.1075 14.1178 11.5217H15.6178ZM15.6178 16.9027V11.5217H14.1178V16.9027H15.6178Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1),
    l("path", {
      d: "M14.8678 16.1526C14.4536 16.1526 14.1178 16.4884 14.1178 16.9026C14.1178 17.3168 14.4536 17.6526 14.8678 17.6526L14.8678 16.1526ZM20.2488 17.6526C20.663 17.6526 20.9988 17.3168 20.9988 16.9026C20.9988 16.4884 20.663 16.1526 20.2488 16.1526L20.2488 17.6526ZM14.8678 17.6526L20.2488 17.6526L20.2488 16.1526L14.8678 16.1526L14.8678 17.6526Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1),
    l("path", {
      d: "M27.398 15.8585C27.398 22.2237 22.238 27.3837 15.8728 27.3837V27.3837C9.50756 27.3837 4.34753 22.2237 4.34753 15.8585V15.8585C4.34753 9.49327 9.50756 4.33325 15.8728 4.33325V4.33325C22.238 4.33325 27.398 9.49327 27.398 15.8585V15.8585Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    l("path", {
      d: "M15.8584 29.7169C8.20464 29.7169 2 23.5123 2 15.8584C2 8.20464 8.20464 2 15.8584 2",
      stroke: "#0AA5FF",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const a = { render: r };
export {
  a as default,
  r as render
};
